import { render, staticRenderFns } from "./FoodTypes.vue?vue&type=template&id=6d3dd7c7&scoped=true&"
import script from "./FoodTypes.vue?vue&type=script&lang=js&"
export * from "./FoodTypes.vue?vue&type=script&lang=js&"
import style0 from "./FoodTypes.vue?vue&type=style&index=0&id=6d3dd7c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3dd7c7",
  null
  
)

export default component.exports